/**
 * Reusable component for editing ResourceLinks
 *
 * NOTE: The Yote _resource assigned to a given ResourceLink is immutable and
 * passed in as a prop to this component.
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';

const ResourceLinkListItem = ({resourceLink}) => {
  return (
    <div className="resource-link-item">
      <div className="-display-name tooltip">
        <div className="-tip-text -bottom">
          <div>
            <a href={resourceLink.downloadUrl ? resourceLink.downloadUrl : resourceLink.url} target="_blank">{resourceLink.downloadUrl ? resourceLink.downloadUrl : resourceLink.url}</a>
          </div>
        </div>
        <div>{resourceLink.name}</div>
      </div>
    </div>
  )
}

ResourceLinkListItem.propTypes = {
  resourceLink: PropTypes.object.isRequired
}

export default ResourceLinkListItem;



// WEBPACK FOOTER //
// modules/resourceLink/components/ResourceLinkListItem.js.jsx